export default __webpack_public_path__ + "static/media/KingPostTrussImg.f6f6984d.png";